// extracted by mini-css-extract-plugin
export default {"logoWrapper":"NavbarBlock_logoWrapper__jyIqE","navbarWrapper":"NavbarBlock_navbarWrapper__UTKby"};